<div class="toasts">
  <div [@toast] *ngFor="let toast of toasts" [ngClass]="{ good: toast.isGood, toast: !toast.component }">
    <div *ngIf="toast.component; else alerts">
      <ng-container *ngComponentOutlet="toast.component.comp; inputs: toast.component.inputs"></ng-container>
    </div>

    <ng-template #alerts>
      <lib-svg [svg]="toast.isGood ? 'fontawesome/check-circle' : 'times-circle'" class="icon white"></lib-svg>
      <span data-source="prismic" [innerHTML]="toast.message" class="p-with-margin"></span>
    </ng-template>
  </div>
</div>
